const DEFAULT_LAYOUT = () => import('@/layout/main-layout.vue');
// const DEFAULT_PAGE = () => import('@/layout/page.vue');

const PROCEEDS = {
  path: '/uju-upload',
  name: 'uju-upload',
  component: DEFAULT_LAYOUT,
  redirect: { name: 'uju-upload-list' },
  meta: {
    title: '上传',
    requiresAuth: true,
    hideChildrenInMenu: true,
    roles: 'uju-upload',
    order: 123
  },
  children: [
    {
      path: '',
      name: 'uju-upload-list',
      component: () => import('@/views/uju-upload/uju-upload.vue'),
      meta: {
        requiresAuth: true,
        roles: 'uju-upload:view',
        title: '上传'
      }
    }
  ]
};

export default PROCEEDS;
